// big hardcoded list of breakthrough meds from skye https://www.notion.so/trypower/PRD-Trial-Listings-Page-v3-15b2b820b09a802eabf1cfeb761b4574
export const breakthroughMeds = [
  'GAZYVA',
  'OBINUTUZUMAB',
  'IMBRUVICA',
  'IBRUTINIB',
  'SOVALDI',
  'SOFOSBUVIR',
  'KALYDECO',
  'IVACAFTOR',
  'ARZERRA',
  'OFATUMUMAB',
  'ZYKADIA',
  'CERITINIB',
  'ZYDELIG',
  'IDELALISIB',
  'IMBRUVICA',
  'IBRUTINIB',
  'PROMACTA',
  'ELTROMBOPAG',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'HARVONI',
  'LEDIPASVIR AND SOFOSBUVIR',
  'ESBRIET',
  'PIRFENIDONE',
  'OFEV',
  'NINTEDANIB',
  'BLINCYTO',
  'BLINATUMOMAB',
  'VIEKIRA PAK',
  'OMBITASVIR AND PARITAPREVIR AND RITONAVIR AND DASABUVIR',
  'OPDIVO',
  'NIVOLUMAB',
  'KALYDECO',
  'IVACAFTOR',
  'IMBRUVICA',
  'IBRUTINIB',
  'IBRANCE',
  'PALBOCICLIB',
  'LUCENTIS',
  'RANIBIZUMAB',
  'KALYDECO',
  'IVACAFTOR',
  'EYLEA',
  'AFLIBERCEPT',
  'RAPAMUNE',
  'SIROLIMUS',
  'RAPAMUNE',
  'SIROLIMUS',
  'ORKAMBI',
  'LUMACAFTOR AND IVACAFTOR',
  'TECHNIVIE',
  'OMBITASVIR, PARITAPREVIR, RITONAVIR',
  'XURIDEN',
  'URIDINE TRIACETATE',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'OPDIVO',
  'NIVOLUMAB',
  'PRAXBIND',
  'IDARUCIZUMAB',
  'STRENSIQ',
  'ASFOTASE ALFA',
  'TAGRISSO',
  'OSIMERTINIB',
  'DARZALEX',
  'DARATUMUMAB',
  'OPDIVO',
  'NIVOLUMAB',
  'EMPLICITI',
  'ELOTUZUMAB',
  'KANUMA',
  'SEBELIPASE ALFA',
  'ALECENSA',
  'ALECTINIB',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'ZEPATIER',
  'ELBASVIR AND GRAZOPREVIR',
  'IBRANCE',
  'PALBOCICLIB',
  'XALKORI',
  'CRIZOTINIB',
  'VENCLEXTA',
  'VENETOCLAX',
  'CABOMETYX',
  'CABOZANTINIB',
  'NUPLAZID',
  'PIMAVANSERIN',
  'IMBRUVICA',
  'IBRUTINIB',
  'LENVIMA',
  'LENVATINIB',
  'OPDIVO',
  'NIVOLUMAB',
  'TECENTRIQ',
  'ATEZOLIZUMAB',
  'EPCLUSA',
  'SOFOSBUVIR AND VELPATASVIR',
  'ILARIS',
  'CANAKINUMAB',
  'ILARIS',
  'CANAKINUMAB',
  'ILARIS',
  'CANAKINUMAB',
  'ORKAMBI',
  'LUMACAFTOR AND IVACAFTOR',
  'TECENTRIQ',
  'ATEZOLIZUMAB',
  'LARTRUVO',
  'OLARATUMAB',
  'OPDIVO',
  'NIVOLUMAB',
  'DARZALEX',
  'DARATUMUMAB',
  'DARZALEX',
  'DARATUMUMAB',
  'RUBRACA',
  'RUCAPARIB',
  'OPDIVO',
  'NIVOLUMAB',
  'KISQALI',
  'RIBOCICLIB',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'BAVENCIO',
  'AVELUMAB',
  'ZEJULA',
  'NIRAPARIB',
  'OCREVUS',
  'OCRELIZUMAB',
  'DUPIXENT',
  'DUPILUMAB',
  'IBRANCE',
  'PALBOCICLIB',
  'INGREZZA',
  'VALBENAZINE',
  'LUCENTIS',
  'RANIBIZUMAB',
  'BRINEURA',
  'CERLIPONASE ALFA',
  'RYDAPT',
  'MIDOSTAURIN',
  'ALUNBRIG',
  'BRIGATINIB',
  'IMFINZI',
  'DURVALUMAB',
  'KISQALI FEMARA CO-PACK',
  'LETROZOLE AND RIBOCICLIB',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'ACTEMRA',
  'TOCILIZUMAB',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'ZYKADIA',
  'CERITINIB',
  'TAFINLAR',
  'DABRAFENIB',
  'MEKINIST',
  'TRAMETINIB',
  'IMBRUVICA',
  'IBRUTINIB',
  'MAVYRET',
  'GLECAPREVIR AND PIBRENTASVIR',
  'VYXEOS',
  'CYTARABINE AND DAUNORUBICIN',
  'BESPONSA',
  'INOTUZUMAB OZOGAMICIN',
  'AUSTEDO',
  'DEUTETRABENAZINE',
  'VERZENIO',
  'ABEMACICLIB',
  'CALQUENCE',
  'ACALABRUTINIB',
  'ZELBORAF',
  'VEMURAFENIB',
  'ALECENSA',
  'ALECTINIB',
  'PREVYMIS',
  'LETTERMOVIR',
  'PREVYMIS',
  'LETTERMOVIR',
  'ADCETRIS',
  'BRENTUXIMAB VEDOTIN',
  'HEMLIBRA',
  'EMICIZUMAB-KXWH',
  'OPDIVO',
  'NIVOLUMAB',
  'SYMDEKO',
  'TEZACAFTOR AND IVACAFTOR',
  'IMFINZI',
  'DURVALUMAB',
  'TROGARZO',
  'IBALIZUMAB-UIYK',
  'ADCETRIS',
  'BRENTUXIMAB VEDOTIN',
  'YERVOY',
  'IPILIMUMAB',
  'OPDIVO',
  'NIVOLUMAB',
  'CRYSVITA',
  'BUROSUMAB-TWZA',
  'TAGRISSO',
  'OSIMERTINIB',
  'TAFINLAR',
  'DABRAFENIB',
  'MEKINIST',
  'TRAMETINIB',
  'TAFINLAR',
  'DABRAFENIB',
  'MEKINIST',
  'TRAMETINIB',
  'GILENYA',
  'FINGOLIMOD',
  'RITUXAN',
  'RITUXIMAB',
  'VENCLEXTA',
  'VENETOCLAX',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'YERVOY',
  'IPILIMUMAB',
  'OPDIVO',
  'NIVOLUMAB',
  'KISQALI',
  'RIBOCICLIB',
  'KRINTAFEL',
  'TAFENOQUINE',
  'AZEDRA',
  'IOBENGUANE I 131',
  'ORKAMBI',
  'LUMACAFTOR/IVACAFTOR',
  'POTELIGEO',
  'MOGAMULIZUMAB-KPKC',
  'ONPATTRO',
  'PATISIRAN',
  'OXERVATE',
  'CENEGERMIN-BKBJ',
  'TAKHZYRO',
  'LANADELUMAB-FLYO',
  'LIBTAYO',
  'CEMIPLIMAB-RWLC',
  'ARIKAYCE AMIKACIN LIPOSOME INHALATION SUSPENSION',
  'AMIKACIN',
  'HEMLIBRA',
  'EMICIZUMAB-KXWH',
  'LORBRENA',
  'LORLATINIB',
  'ADCETRIS',
  'BRENTUXIMAB VEDOTIN',
  'PROMACTA',
  'ELTROMBOPAG',
  'GAMIFANT',
  'EMAPALUMAB-LZSG',
  'VENCLEXTA',
  'VENETOCLAX',
  'VITRAKVI',
  'LAROTRECTINIB',
  'VITRAKVI',
  'LAROTRECTINIB',
  'FIRDAPSE',
  'AMIFAMPRIDINE',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'ELZONRIS',
  'TAGRAXOFUSP-ERZS',
  'KISQALI FEMARA CO-PACK',
  'LETROZOLE AND RIBOCICLIB',
  'SPRAVATO',
  'ESKETAMINE',
  'DUPIXENT',
  'DUPILUMAB',
  'ZULRESSO',
  'BREXANOLONE',
  'IBRANCE',
  'PALBOCICLIB',
  'BALVERSA',
  'ERDAFITINIB',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'KADCYLA',
  'ADO-TRASTUZUMAB EMTANSINE',
  'VYNDAQEL',
  'TAFAMIDIS MEGLUMINE',
  'BAVENCIO',
  'AVELUMAB',
  'VENCLEXTA',
  'VENETOCLAX',
  'EMGALITY',
  'GALCANEZUMAB',
  'POLIVY',
  'POLATUZUMAB VEDOTIN-PIIQ',
  'TURALIO',
  'PEXIDARTINIB',
  'ROZLYTREK',
  'ENTRECTINIB',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'LENVIMA',
  'LENVATINIB',
  'TRIKAFTA',
  'ELEXACAFTOR AND TEZACAFTOR AND IVACAFTOR',
  'BRUKINSA',
  'ZANUBRUTINIB',
  'ADAKVEO',
  'CRIZANLIZUMAB-TMCA',
  'GIVLAARI',
  'GIVOSIRAN',
  'CALQUENCE',
  'ACALABRUTINIB',
  'CALQUENCE',
  'ACALABRUTINIB',
  'OXBRYTA',
  'VOXELOTOR',
  'PADCEV',
  'ENFORTUMAB VEDOTIN-EJFV',
  'ENHERTU',
  'FAM-TRASTUZUMAB DERUXTECAN-NXKI',
  'AYVAKIT',
  'AVAPRITINIB',
  'TEPEZZA',
  'TEPROTUMUMAB-TRBW',
  'OFEV',
  'NINTEDANIB',
  'YERVOY',
  'IPILIMUMAB',
  'OPDIVO',
  'NIVOLUMAB',
  'KOSELUGO',
  'SELUMETINIB',
  'JELMYTO',
  'MITOMYCIN',
  'TUKYSA',
  'TUCATINIB',
  'PEMAZYRE',
  'PEMIGATINIB',
  'TRODELVY',
  'SACITUZUMAB GOVITECAN-HZIY',
  'TABRECTA',
  'CAPMATINIB',
  'RETEVMO',
  'SELPERCATINIB',
  'POMALYST',
  'POMALIDOMIDE',
  'RUBRACA',
  'RUCAPARIB',
  'QINLOCK',
  'RIPRETINIB',
  'ARTESUNATE',
  'AMIVAS LLC',
  'AVASTIN',
  'BEVACIZUMAB',
  'TECENTRIQ',
  'ATEZOLIZUMAB',
  'UPLIZNA',
  'INEBILIZUMAB-CDON',
  'RUKOBIA',
  'FOSTEMSAVIR',
  'MONJUVI',
  'TAFASITAMAB-CXIX',
  'SPRAVATO',
  'ESKETAMINE',
  'BLENREP',
  'BELANTAMAB MAFODOTIN-BLMF',
  'ENSPRYNG',
  'SATRALIZUMAB-MWGE',
  'GAVRETO',
  'PRALSETINIB',
  'WAKIX',
  'PITOLISANT',
  'INMAZEB',
  'ATOLTIVIMAB, MAFTIVIMAB, AND ODESIVIMAB-EBGN',
  'ZOKINVY',
  'LONAFARNIB',
  'OXLUMO',
  'LUMASIRAN',
  'DANYELZA',
  'NAXITAMAB-GQGK',
  'IMCIVREE',
  'SETMELANOTIDE',
  'GAVRETO',
  'PRALSETINIB',
  'BENLYSTA',
  'BELIMUMAB',
  'TAGRISSO',
  'OSIMERTINIB',
  'EBANGA',
  'ANSUVIMAB-ZYKL',
  'XALKORI',
  'CRIZOTINIB',
  'ENHERTU',
  'FAM-TRASTUZUMAB DERUXTECAN-NXKI',
  'UKONIQ',
  'UMBRALISIB',
  'EVKEEZA',
  'EVINACUMAB-DGNB',
  'COSELA',
  'TRILACICLIB',
  'NULIBRY',
  'FOSDENOPTERIN',
  'ACTEMRA',
  'TOCILIZUMAB',
  'ARCALYST',
  'RILONACEPT',
  'JEMPERLI',
  'DOSTARLIMAB-GXLY',
  'FARXIGA',
  'DAPAGLIFLOZIN',
  'ZYNRELEF',
  'BUPIVACAINE AND MELOXICAM',
  'RYBREVANT',
  'AMIVANTAMAB-VMJW',
  'LUMAKRAS',
  'SOTORASIB',
  'AYVAKIT',
  'AVAPRITINIB',
  'AYVAKIT',
  'AVAPRITINIB',
  'REZUROCK',
  'BELUMOSUDIL',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'NEXVIAZYME',
  'AVALGLUCOSIDASE ALFA-NGPT',
  'LENVIMA',
  'LENVATINIB',
  'KORSUVA',
  'DIFELIKEFALIN',
  'EXKIVITY',
  'MOBOCERTINIB',
  'CABOMETYX',
  'CABOZANTINIB',
  'LIVMARLI',
  'MARALIXIBAT',
  'SCEMBLIX',
  'ASCIMINIB',
  'SCEMBLIX',
  'ASCIMINIB',
  'FYARRO',
  'SIROLIMUS',
  'LIVTENCITY',
  'MARIBAVIR',
  'ORENCIA',
  'ABATACEPT',
  'OXBRYTA',
  'VOXELOTOR',
  'OXBRYTA',
  'VOXELOTOR',
  'APRETUDE',
  'CABOTEGRAVIR',
  'CIBINQO',
  'ABROCITINIB',
  'KIMMTRAK',
  'TEBENTAFUSP-TEBN',
  'ENJAYMO',
  'SUTIMLIMAB-JOME',
  'PLUVICTO',
  'LUTETIUM Lu 177 VIPIVOTIDE TETRAXETAN',
  'VIJOICE',
  'ALPELISIB',
  'CAMZYOS',
  'MAVACAMTEN',
  'ENHERTU',
  'FAM-TRASTUZUMAB DERUXTECAN-NXKI',
  'DUPIXENT',
  'DUPILUMAB',
  'TIBSOVO',
  'IVOSIDENIB',
  'DUPIXENT',
  'DUPILUMAB',
  'OLUMIANT',
  'BARICITINIB',
  'IMCIVREE',
  'SETMELANOTIDE',
  'ENHERTU',
  'FAM-TRASTUZUMAB DERUXTECAN-NXKI',
  'ENHERTU',
  'FAM-TRASTUZUMAB DERUXTECAN-NXKI',
  'AUVELITY',
  'DEXTROMETHORPHAN HYDROBROMIDE AND BUPROPION HYDROCHLORIDE',
  'PEMAZYRE',
  'PEMIGATINIB',
  'XENPOZYME',
  'OLIPUDASE ALFA-RPCP',
  'SPEVIGO',
  'SPESOLIMAB-SBZO',
  'LYTGOBI',
  'FUTIBATINIB',
  'TECVAYLI',
  'TECLISTAMAB-CQYV',
  'TZIELD',
  'TEPLIZUMAB-MZWV',
  'TECENTRIQ',
  'ATEZOLIZUMAB',
  'KRAZATI',
  'ADAGRASIB',
  'LUNSUMIO',
  'MOSUNETUZUMAB-AXGB',
  'SUNLENCA',
  'LENACAPAVIR',
  'SUNLENCA',
  'LENACAPAVIR',
  'LEQEMBI',
  'LECANEMAB-IRMB',
  'TUKYSA',
  'TUCATINIB',
  'ENJAYMO',
  'SUTIMLIMAB-JOME',
  'TAFINLAR',
  'DABRAFENIB',
  'KEYTRUDA',
  'PEMBROLIZUMAB',
  'PADCEV',
  'ENFORTUMAB VEDOTIN-EJFV',
  'JEMPERLI',
  'DOSTARLIMAB-GXLY',
  'IZERVAY',
  'AVACINCAPTAD PEGOL',
  'TALVEY',
  'TALQUETAMAB-TGVS',
  'ELREXFIO',
  'ELRANATAMAB-BCMM',
  'POMBILITI',
  'CIPAGLUCOSIDASE ALFA-ATGA',
  'OPFOLDA',
  'MIGLUSTAT',
  'RIVFLOZA',
  'NEDOSIRAN',
  'TIBSOVO',
  'IVOSIDENIB',
  'LOQTORZI',
  'TORIPALIMAB-TPZI',
  'OGSIVEO',
  'NIROGACESTAT',
  'FABHALTA',
  'IPTACOPAN',
  'IWILFIN',
  'EFLORNITHINE',
  'EOHILIA',
  'BUDESONIDE',
  'XOLAIR',
  'OMALIZUMAB',
  'TAGRISSO',
  'OSIMERTINIB',
  'REZDIFFRA',
  'RESMETIROM',
  'SPEVIGO',
  'SPESOLIMAB-SBZO',
  'WINREVAIR',
  'SOTATERCEPT-CSRK',
  'VOYDEYA',
  'DANICOPAN',
  'ENHERTU',
  'FAM-TRASTUZUMAB DERUXTECAN-NXKI',
  'ANKTIVA',
  'NOGAPENDEKIN ALFA INBAKICEPT-PMLN',
  'OJEMDA TABLET',
  'TOVORAFENIB',
  'OJEMDA ORAL SUSPENSION',
  'TOVORAFENIB',
  'IMDELLTRA',
  'TARLATAMAB-DLLE',
  'IQIRVO',
  'ELAFIBRANOR',
  'AUGTYRO',
  'REPOTRECTINIB',
  'BLINCYTO',
  'BLINATUMOMAB',
  'KRAZATI',
  'ADAGRASIB',
  'EPKINLY',
  'EPCORITAMAB-BYSP',
  'KISUNLA',
  'DONANEMAB-AZBT',
  'VORANIGO',
  'VORASIDENIB',
  'NEMLUVIO',
  'NEMOLIZUMAB-ILTO',
  'LIVDELZI',
  'SELADELPAR',
  'MIPLYFFA',
  'ARIMOCLOMOL',
  'TAGRISSO',
  'OSIMERTINIB',
  'DUPIXENT',
  'DUPILUMAB',
]
